module.exports = __webpack_public_path__ + "img/male-youngchild-hand.724eef6b.svg";